import React from "react";
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Alert from "@mui/material/Alert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function AddressCard(props) {
  const {
    title,
    error = null,
    content = null,
    onKeyDown,
    isSelected,
    isVerifiedAddress = false,
    onAddressSelection,
  } = props;

  const index = isVerifiedAddress ? 2 : 1;

  const errorContent =
    isVerifiedAddress && error ? (
      <Alert severity="warning">
        {error?.data?.message || "Could not process request, please try later."}
      </Alert>
    ) : null;

  const handleAddressSelection = () => {
    if (index === 1 || !error) onAddressSelection(index);
  };

  const handleKeyDown = (e) => {
    if (index === 1 || !error) onKeyDown(e, index);
  };

  return (
    <Card
      elevation={2}
      onClick={handleAddressSelection}
      onKeyDown={handleKeyDown}
      className={isVerifiedAddress ? "verifyCard" : "userAddress"}
      tabIndex={0}
    >
      <CardHeader
        title={title}
        slotProps={{ title: { component: "h3" } }}
        action={isSelected && <CheckCircleIcon fontSize="small" />}
      />
      <Divider />
      <CardContent>
        {errorContent}
        {content}
      </CardContent>
    </Card>
  );
}

export default AddressCard;
AddressCard.propTypes = {
  title: PropTypes.string.isRequired,
  error: PropTypes.shape({
    data: PropTypes.shape({ message: PropTypes.string }),
  }),
  content: PropTypes.arrayOf(PropTypes.element),
  onKeyDown: PropTypes.func.isRequired,
  isVerifiedAddress: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  onAddressSelection: PropTypes.func.isRequired,
};
AddressCard.defaultProps = {
  error: null,
  content: null,
  isVerifiedAddress: false,
};
